import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { useAuth } from "@/components/providers/auth-context";
import { useTRPC } from "@/trpc/client";

export const useUserPlanQuery = () => {
  const { userId } = useAuth();
  const trpc = useTRPC();

  return useQuery(
    trpc.users.getPlanLimit.queryOptions(undefined, {
      enabled: !!userId,
      staleTime: 300000,
    }),
  );
};

export const useUserPlanSuspenseQuery = () => {
  const trpc = useTRPC();

  return useSuspenseQuery(
    trpc.users.getPlanLimit.queryOptions(undefined, {
      staleTime: 300000,
    }),
  );
};
